if (!window.__cartSubscriptionJsLoaded) {
window.__cartSubscriptionJsLoaded = true;

if (typeof window.refreshCartPage !== 'function') {
  window.refreshCartPage = function () {};
}

window.__cartMutationLock = window.__cartMutationLock || false;

function getPlanKeyForQty(qty) {
  if (qty >= 6) return '180';
  if (qty >= 3) return '90';
  if (qty >= 1) return '30';
  return null;
}

document.addEventListener('click', async function (e) {
  const btn = e.target.closest('.subscription-upgrade-btn');
  if (!btn) return;
  if (btn.closest('#main-cart-items')) return; // page has its own handler, don't double-fire
  if (window.__cartMutationLock) return;
  if (btn.dataset.busy === '1') return;
  btn.dataset.busy = '1';
  window.__cartMutationLock = true;

  const item = btn.closest('.cart-item');
  if (!item) { console.warn('[sub] no .cart-item'); btn.dataset.busy = '0'; window.__cartMutationLock = false; return; }
  const select = item.querySelector('.subscription-plan-select');
  if (!select) { console.warn('[sub] no .subscription-plan-select'); btn.dataset.busy = '0'; window.__cartMutationLock = false; return; }
  const line = parseInt(btn.dataset.line, 10);
  const variantId = parseInt(btn.dataset.variantId, 10);
  const isSubscribed = btn.dataset.subscribed === 'true';
  const planMap = JSON.parse(select.dataset.planMap || '{}');
  const qtyInput = item.querySelector('.quantity__input.real-qty');
  const currentQty = parseInt(qtyInput?.value || '1', 10);
  const planKey = getPlanKeyForQty(currentQty);
  const plan = planKey ? planMap[planKey] : null;
  console.log('[sub] qty', currentQty, 'planKey', planKey, 'plan', plan);

  try {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: 0 })
    });
    if (isSubscribed) {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: currentQty })
      });
    } else {
      const planKey2 = getPlanKeyForQty(currentQty);
      const plan2 = planKey2 ? planMap[planKey2] : null;
      if (plan2) {
        const sellingPlanId = parseInt(
          plan2.planId.replace('gid://shopify/SellingPlan/', ''),
          10
        );
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: variantId,
            quantity: currentQty,
            selling_plan: sellingPlanId
          })
        });
      } else {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: currentQty })
        });
      }
    }
    refreshCartDrawer();
    refreshCartPage();
  } catch (err) {
    console.log('Subscription toggle error:', err);
  }
  finally {
    btn.dataset.busy = '0';
    window.__cartMutationLock = false;
  }
});

document.addEventListener('change', async function (e) {
  const dropdown = e.target.closest('.quantity-dropdown');
  if (!dropdown) return;
  if (dropdown.closest('#main-cart-items')) return;
  if (window.__cartMutationLock) return;
  window.__cartMutationLock = true;

  const item = dropdown.closest('.cart-item');
  if (!item) { window.__cartMutationLock = false; return; }
  const newQty = parseInt(dropdown.value, 10);
  const realQtyInput = item.querySelector('.quantity__input.real-qty');
  const btn = item.querySelector('.subscription-upgrade-btn');
  const select = item.querySelector('.subscription-plan-select');
  if (realQtyInput) realQtyInput.value = newQty;
  if (!btn) { window.__cartMutationLock = false; return; }
  const line = parseInt(btn.dataset.line, 10);
  const variantId = parseInt(btn.dataset.variantId, 10);
  const isSubscribed = btn.dataset.subscribed === 'true';
  try {
    if (isSubscribed && select) {
      const planMap = JSON.parse(select.dataset.planMap || '{}');
      const planKey = getPlanKeyForQty(newQty);
      const plan = planKey ? planMap[planKey] : null;
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: 0 })
      });
      if (plan) {
        const sellingPlanId = parseInt(
          plan.planId.replace('gid://shopify/SellingPlan/', ''),
          10
        );
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: variantId,
            quantity: newQty,
            selling_plan: sellingPlanId
          })
        });
      } else {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: newQty })
        });
      }
    } else {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: newQty })
      });
    }
    refreshCartDrawer();
    refreshCartPage();
  } catch (err) {
    console.log('Quantity dropdown sync error:', err);
  } finally {
    window.__cartMutationLock = false;
  }
}, true);

document.addEventListener('change', async function (e) {
  const qtyInput = e.target.closest('.quantity__input.real-qty');
  if (!qtyInput) return;
  if (qtyInput.closest('#main-cart-items')) return;
  const item = qtyInput.closest('.cart-item');
  if (!item) return;
  const btn = item.querySelector('.subscription-upgrade-btn');
  const select = item.querySelector('.subscription-plan-select');
  if (!btn || !select) return;
  if (btn.dataset.subscribed !== 'true') return; // only auto-sync if already subscribed
  if (window.__cartMutationLock) return;
  window.__cartMutationLock = true;

  const planMap = JSON.parse(select.dataset.planMap || '{}');
  const qty = parseInt(qtyInput.value, 10);
  const planKey = getPlanKeyForQty(qty);
  if (!planKey) { window.__cartMutationLock = false; return; }
  const plan = planMap[planKey];
  if (!plan) { window.__cartMutationLock = false; return; }
  e.stopImmediatePropagation();
  const line = parseInt(btn.dataset.line, 10);
  const variantId = parseInt(btn.dataset.variantId, 10);
  const sellingPlanId = parseInt(
    plan.planId.replace('gid://shopify/SellingPlan/', ''),
    10
  );
  try {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: 0 })
    });
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: qty,
        selling_plan: sellingPlanId
      })
    });
    refreshCartDrawer();
    refreshCartPage();
  } catch (err) {
    console.log('Quantity -> Plan re-sync error:', err);
  } finally {
    window.__cartMutationLock = false;
  }
}, true);

function refreshCartDrawer() {
  fetch('/?section_id=cart-drawer')
    .then((response) => response.text())
    .then((html) => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newItems = doc.querySelector('#CartDrawer-CartItems');
      const currentItems = document.querySelector('#CartDrawer-CartItems');
      if (newItems && currentItems) {
        currentItems.innerHTML = newItems.innerHTML;
      }
      const newFooter = doc.querySelector('#CartDrawer .drawer__footer');
      const currentFooter = document.querySelector('#CartDrawer .drawer__footer');
      if (newFooter && currentFooter) {
        currentFooter.innerHTML = newFooter.innerHTML;
      }
    })
    .catch(console.error);
}
}